import { useConst } from '@execonline-inc/react-hooks.private';
import { observer } from 'mobx-react';
import { Route, Routes } from 'react-router';
import LearningCollections from '..';
import Main from '../../../BrowserSupport/Main';
import { currentUserStore } from '../../../CurrentUserStore';
import { findLink } from '../../../LinkyLinky';
import I18nTitle from '../../../Title/I18nTitle';
import { T } from '../../../Translations';
import NotFound from '../../NotFound';
import MainNav from '../../Platform/MainNav';
import DeepLinks from '../LearningCollection/DeepLinks';
import Edit from '../LearningCollection/Edit';
import Invitations from '../LearningCollection/Invitations';
import New from '../LearningCollection/New';
import LearningCollectionsStore from '../Store';

const Dashboard = () => {
  const learningCollectionsStore = useConst(() => new LearningCollectionsStore());

  return (
    <>
      <I18nTitle title="Learning Collections" />
      <div>
        <MainNav />
        <Main id="main" className="min-h-[calc(100vh-150px)]">
          <div>
            <h1 className="[&:not(focus)]:[&:not(active)]:sr-only">
              <T kind="Learning Collections" />
            </h1>
            <div>
              <h1 className="[&:not(focus)]:[&:not(active)]:sr-only">
                <T kind="Learning Collections" />
              </h1>
              <div>
                <Routes>
                  <Route
                    path="/"
                    element={<LearningCollections store={learningCollectionsStore} />}
                  />
                  <Route path="/new" element={<New store={learningCollectionsStore} />} />
                  <Route
                    path="/:id/edit/:step"
                    element={<Edit store={learningCollectionsStore} />}
                  />
                  <Route
                    path="/:id/deep-links"
                    element={<DeepLinks store={learningCollectionsStore} />}
                  />
                  {findLink('learning-collection-invitations', currentUserStore.links)
                    .map(() => <Route path="/:id/invitations" element={<Invitations />} />)
                    .getOrElse(() => (
                      <Route path="*" element={<NotFound />} />
                    ))}
                </Routes>
              </div>
            </div>
          </div>
        </Main>
      </div>
    </>
  );
};

export default observer(Dashboard);
